// extracted by mini-css-extract-plugin
export default {"screen":"adults-only-screen_screen__pK1Vs","card":"adults-only-screen_card__q93QO","message":"adults-only-screen_message__UbzcK"};